import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useLocation, useSearchParams } from "react-router-dom";
import CollabTemplates from "./CollabTemplates";
import ConsentTemplates from "./ConsentTemplates";
import UserdefinedTemplates from "./UserdefinedTemplates";

const Templates = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Always read from URL; default to "consent"
  const tabFromUrl = searchParams.get("tab") || "consent";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const handleTabChange = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  useEffect(() => {
    const tab = searchParams.get("tab") || "consent";
    if (tab !== activeTab) setActiveTab(tab);
  }, [location.search]);

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <h1>
        <strong>Templates</strong>
      </h1>
      <Tabs activeKey={activeTab} onSelect={handleTabChange} className="mb-3">
        <Tab eventKey="consent" title="Consent Templates">
          <ConsentTemplates />
        </Tab>
        <Tab eventKey="collab" title="Collaboration Templates">
          <CollabTemplates />
        </Tab>
         <Tab eventKey="userCollab" title="My Templates">
          <UserdefinedTemplates />
        </Tab>
      </Tabs>
    </div>
  );
};

export default Templates;
